import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const DepartmentModal = ({ show, onClose, onSave, initialData }) => {
  const [formData, setFormData] = useState({
    id: "",
    departmentCode: "",
    name: "",
  });

  useEffect(() => {
    if (initialData) {
      setFormData({
        id: initialData.id || "",
        departmentCode: initialData.departmentCode || "",
        name: initialData.name || "",
      });
    } else {
      setFormData({
        id: "",
        departmentCode: "",
        name: "",
      });
    }
  }, [initialData, show]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSave = () => {
    if (!formData.departmentCode.trim())
      return alert("Department Code không được để trống");

    if (formData.departmentCode.length > 20)
      return alert("Department Code tối đa 20 ký tự");

    if (!formData.name.trim())
      return alert("Tên phòng ban không được để trống");

    if (formData.name.length > 200)
      return alert("Tên phòng ban tối đa 200 ký tự");

    const payload = {
      id: formData.id || 0,
      departmentCode: formData.departmentCode.trim(),
      name: formData.name.trim(),
    };

    onSave(payload);
    onClose();
  };

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          {formData.id ? "Edit Department" : "Add New Department"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          {/* Department Code */}
          <Form.Group className="mb-3">
            <Form.Label>Department Code</Form.Label>
            <Form.Control
              type="text"
              name="departmentCode"
              value={formData.departmentCode}
              onChange={handleChange}
              placeholder="Enter department code"
              maxLength={20}
            />
            <Form.Text className="text-muted">
              Tối đa 20 ký tự
            </Form.Text>
          </Form.Group>

          {/* Name */}
          <Form.Group className="mb-3">
            <Form.Label>Department Name</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter department name"
              maxLength={200}
            />
            <Form.Text className="text-muted">
              Tối đa 200 ký tự
            </Form.Text>
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="success" onClick={handleSave}>
          {formData.id ? "Save Changes" : "Add Department"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DepartmentModal;